import React from 'react';
import { routes } from 'constants/config';

const QuestionMetricsTableRow = ({
  questionMetric,
  lessonId,
  currentGroupId,
}) => {
  const { question, withChoices, canViewQuestion } = questionMetric;
  const questionSubject =
    question.subject ||
    (questionMetric.type === 'RolePlay'
      ? t('lesson_performance.no_role_play_title')
      : t('lesson_performance.no_question_subject'));

  const linkText = questionMetric.openEnded
    ? t('lesson_performance.responses_count', {
        count: questionMetric.answerCount,
      })
    : questionMetric.percentCorrect;

  const contentId =
    question.contentId || question.contentId === 0
      ? question.contentId
      : question.id;
  return (
    <tr>
      <td className="PerformanceTable-rowHead">{question.position}</td>
      <td className="text-wrap">{questionSubject}</td>
      <td
        id={`metrics_${question.modelName}_${contentId}`}
        className="PerformanceTable-shrink has_popover"
        data-behavior="persist_on_click expandable collapse_on_outside_click"
      >
        {withChoices && (
          <a
            href={routes.LESSON_OVERVIEW.QUESTION_METRICS(
              lessonId,
              contentId,
              null,
              currentGroupId,
            )}
            className="expand_button decorated u-nowrap"
            data-behavior="one_click_popover"
          >
            <span>{linkText}</span>
          </a>
        )}
        {!withChoices && (
          <span className="u-nowrap">
            {canViewQuestion && (
              <a
                href={
                  questionMetric.type === 'RolePlay'
                    ? routes.LESSON_OVERVIEW.ROLE_PLAY_FEEDBACKS(
                        lessonId,
                        contentId,
                        currentGroupId,
                      )
                    : routes.LESSON_OVERVIEW.QUESTION(
                        lessonId,
                        contentId,
                        currentGroupId,
                      )
                }
                className="decorated"
              >
                {linkText}
              </a>
            )}
            {!canViewQuestion && <span>{linkText}</span>}
          </span>
        )}
      </td>
    </tr>
  );
};
export default QuestionMetricsTableRow;
